import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { API_BASE_URL, handleFile, renderModal, closeModal, fetchJsonFromUrl } from './Common';
import './AddData.css';

import axios from 'axios';

import { ReactComponent as UploadIcon } from '../icons/upload.svg';
import { ReactComponent as MugIcon } from '../icons/mug.svg';
import { ReactComponent as FilecheckIcon } from '../icons/filecheck.svg';

function AddData({
  setTableColumnData,
  setTables,
  projectId,
}) {

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedOption, setSelectedOption] = useState('url'); // State variable to track selected option
  const [healthData, setHealthData] = useState([]);
  const [url, setURL] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [modalIconId, setModalIconId] = useState(1);

  const [filesSelected, setFilesSelected] = useState(false);
  const [isCreating, setIsCreating] = useState(false);

  const handleUpdateProject = async () => {
    try {
      setIsCreating(true);
      const token = localStorage.getItem('token');

      let dataToUpload = [];
      if (selectedOption === 'url') {
        const urlData = await fetchJsonFromUrl(url);
        if (urlData) {
          dataToUpload = urlData;
        } else {
          console.error('Failed to fetch data from URL');
          setIsCreating(false);
          return;
        }
      } else if (selectedOption === 'upload') {
        dataToUpload = healthData;
      }

      // Handle the "empty table" option by sending an empty data array
      if (selectedOption === 'empty') {
  dataToUpload = [
    {
      sheetName: "Tabela",
      data: [
        ["Coluna 1", "Coluna 2", "Coluna 3"], // Column headers
        ["", "", ""],                      // Row 1 (empty)
        ["", "", ""],                      // Row 2 (empty)
        ["", "", ""]                       // Row 3 (empty)
      ]
    }
  ];
}


      await axios.post(`${API_BASE_URL}/add-data`, {
        healthData: dataToUpload,
        projectId
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const response = await axios.get(`${API_BASE_URL}/tables/${projectId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setTables(response.data.tables);

      const response2 = await axios.get(`${API_BASE_URL}/column-data/${projectId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setTableColumnData(response2.data.columnData);

      setIsCreating(false);

      setUploadedFiles([]);
      setFilesSelected(false);
      setHealthData([]);
      setURL('');

      setModalMessage("Projeto atualizado!");
      setModalMessageColor('#41BBC9');
      setModalIconId(1);
      setIsModalOpen(true);

    } catch (error) {
      console.error('Error adding data to project:', error);
      setIsCreating(false);

      setUploadedFiles([]);
      setFilesSelected(false);
      setHealthData([]);
      setURL('');

      setModalMessage("Não foi possível atualizar...");
      setModalMessageColor('#E5004E');
      setModalIconId(2);
      setIsModalOpen(true);
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      let allFilesData = [];
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const result = event.target.result;
          handleFile(file, result, allFilesData, acceptedFiles.length, setFilesSelected, setHealthData);
          setUploadedFiles(prevFiles => [...prevFiles, file]);
        };
        reader.readAsBinaryString(file);
      });
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ['.xlsx', '.ods', '.csv', '.json'],
    multiple: true,
  });

  return (
    <div className="home-container">
      <h2>Atualizar Projeto</h2>
      <p>Upload de ficheiros para atualizar projeto</p>

      {isCreating && (
        <div className="loading-overlay">
          <MugIcon />
          <div className="loading-message">A carregar os dados...</div>
          <div className="loading-spinner"></div>
        </div>
      )}

      <header>
        <div className="create-project">
          {/* URL Option */}
          <p className="project-name-label">URL</p>
          {selectedOption !== 'url' && (
            <div className="radio-option">
              <input
                type="radio"
                name="option"
                value="url"
                checked={selectedOption === 'url'}
                onChange={() => setSelectedOption('url')}
              />
            </div>
          )}
          {selectedOption === 'url' && (
            <input
              type="text"
              placeholder="Inserir URL"
              value={url}
              onChange={(e) => setURL(e.target.value)}
            />
          )}

          {/* Upload Option */}
          <p className="project-name-label">Upload de ficheiros</p>
          {selectedOption !== 'upload' && (
            <div className="radio-option">
              <input
                type="radio"
                name="option"
                value="upload"
                checked={selectedOption === 'upload'}
                onChange={() => setSelectedOption('upload')}
              />
            </div>
          )}
          {selectedOption === 'upload' && (
            <div className="dropzone-container">
              <div {...getRootProps({ className: 'dropzone' })}>
                {uploadedFiles.length === 0 && (
                  <>
                    <UploadIcon />
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <p><span className="yellow-text">Solte aqui...</span></p>
                    ) : (
                      <>
                        <p>
                          <span className="yellow-text">Clique para upload</span>
                          <span className="blue-text"> ou arraste e
                            <span className="green-text"> solte</span>
                          </span>
                        </p>
                        <p><span className="red-text">(ODS, XLSX, CSV, XML, JSON)</span></p>
                      </>
                    )}
                  </>
                )}
                {uploadedFiles.length > 0 && (
                  <>
                    <FilecheckIcon />
                    <p className="file-list-header">Ficheiro inserido!</p>
                    <ul>
                      {uploadedFiles.map((file, index) => (
                        <li key={index} className="file-item">{file.name}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Empty Table Option */}
          <p className="project-name-label">Tabela vazia</p>
          <div className="radio-option">
            <input
              type="radio"
              name="option"
              value="empty"
              checked={selectedOption === 'empty'}
              onChange={() => setSelectedOption('empty')}
            />
          </div>

          {(selectedOption === 'upload' && filesSelected) || (selectedOption === 'url' && url) || selectedOption === 'empty' ? (
            <div className="create-project">
              <button
                className="button"
                style={{
                  position: 'fixed',
                  bottom: '37px',
                  right: '37px'
                }}
                onClick={() => handleUpdateProject()}
              >
                Atualizar projeto
              </button>
            </div>
          ) : null}
        </div>
      </header>

      {renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}
    </div>
  );
}

export default AddData;
